module.exports = __webpack_public_path__ + "img/smiley O.dcdb2d0f.svg";